import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { SkyBetOddsLink } from '../SkyBetOddsLink';

export const RunnerCard = ({
    clothNumber,
    horseName,
    jockeyName,
    trainerName,
    silk,
    showSkybetLink,
    skybetLinkHref
}) => {
    return (
        <Styled.Wrapper>
            <Styled.RunnerWrapper>
                <Styled.LeftBody>
                    <Styled.ClothNumber>{clothNumber}</Styled.ClothNumber>
                    <Styled.Silk src={silk ?? '/img/default-silk.png'} />
                </Styled.LeftBody>
                <Styled.RightBody>
                    <Styled.HorseName>{horseName}</Styled.HorseName>
                    <Styled.TrainerAndJockey>
                        <strong>T</strong>: {trainerName}
                        <Styled.Divider> | </Styled.Divider>
                        <strong>J</strong>: {jockeyName}
                    </Styled.TrainerAndJockey>
                </Styled.RightBody>
            </Styled.RunnerWrapper>
            {showSkybetLink && <SkyBetOddsLink href={skybetLinkHref} />}
        </Styled.Wrapper>
    );
};

RunnerCard.defaultProps = {
    clothNumber: '',
    horseName: '-',
    jockeyName: '-',
    trainerName: '-',
    silk: '/img/default-silk.png',
    showSkybetLink: false,
    skybetLinkHref: 'https://skybet.com'
};

RunnerCard.propTypes = {
    clothNumber: PropTypes.string,
    horseName: PropTypes.string,
    jockeyName: PropTypes.string,
    trainerName: PropTypes.string,
    silk: PropTypes.string,
    showSkybetLink: PropTypes.bool,
    skybetLinkHref: PropTypes.string
};

export default RunnerCard;
